import useMeetingLeftLogic from '@/hooks/useMeetingLeftLogic'
import { MeetingHeader } from '@/components/molecules/Header/MeetingHeader'
import { AppTemplate } from '@/components/templates/AppTemplate/AppTemplate'
import { Card, CardTitle, CardContent } from '@/components/ui/Card/Card'
import { Button } from '@/components/ui/Button/Button'
import { StarRating } from '@/components/molecules/StarRating/StarRating'

type MeetingLeftPageProps = {
  meetingType: 'phone' | 'video'
}

const CONTENT = {
  phone: {
    title: "Dites-nous comment était la qualité de l'appel.",
    primaryButton: 'Fermer',
    secondaryButton: 'Appeler de nouveau'
  },
  video: {
    title: 'Avant de partir, dites-nous comment était la qualité de la visio',
    primaryButton: 'Évaluer le rendez-vous',
    secondaryButton: 'Revenir sur la visio'
  }
} as const

export function MeetingLeftPage({ meetingType }: MeetingLeftPageProps) {
  const { appointmentId, rating, isSubmitting, handleRatingChange, handleReturnToWaitingRoom, handleEvaluateAppointment } =
    useMeetingLeftLogic(meetingType)

  if (!appointmentId) {
    return null
  }

  const content = CONTENT[meetingType]
  const isPhone = meetingType === 'phone'

  return (
    <AppTemplate header={<MeetingHeader showVideocallTag />}>
      <Card className="w-full min-w-0 max-w-full lg:max-w-5xl shadow-none">
        <CardContent className="flex flex-col gap-y-20 justify-center lg:justify-normal items-center py-32 lg:py-0 p-4 lg:p-20 h-[calc(100dvh-64px)] lg:h-auto min-w-0 overflow-x-hidden">
          <CardTitle className="text-center text-xl font-medium">{content.title}</CardTitle>
          <StarRating rating={rating} onRatingChange={handleRatingChange} disabled={isSubmitting} size="lg" />
          <div className="flex flex-col lg:flex-row w-full lg:w-[495px] gap-x-6 gap-y-2">
            {isPhone ? (
              <>
                <Button variant="default" onClick={handleEvaluateAppointment} className="flex-1 font-medium py-4">
                  {content.primaryButton}
                </Button>
                <Button
                  variant="outline"
                  onClick={handleReturnToWaitingRoom}
                  className="flex-1 bg-[#F3F3F6] border-none text-sm font-medium py-4"
                >
                  {content.secondaryButton}
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="outline"
                  onClick={handleReturnToWaitingRoom}
                  className="flex-1 bg-[#F3F3F6] border-none text-sm font-medium py-4"
                >
                  {content.secondaryButton}
                </Button>
                <Button variant="default" onClick={handleEvaluateAppointment} className="flex-1 font-medium py-4">
                  {content.primaryButton}
                </Button>
              </>
            )}
          </div>
        </CardContent>
      </Card>
    </AppTemplate>
  )
}
